const BANK_ACCOUNT_UPDATED = 'banking:account-updated'
const BANK_ACCOUNT_ASSIGNED = 'banking:account-assigned'
const BANK_ACCOUNT_UNASSIGNED = 'banking:account-unassigned'

export {BANK_ACCOUNT_UPDATED, BANK_ACCOUNT_ASSIGNED, BANK_ACCOUNT_UNASSIGNED}
